export interface GenerationLanguage {
  /** ISO code sent to the backend as the `language` generation directive. */
  code: string;
  /** Label shown in the picker, written in its own language/script. */
  label: string;
}

/** Mirrors the three locales the platform ships UI for, so generation stays supportable end to end. */
export const GENERATION_LANGUAGES: GenerationLanguage[] = [
  { code: 'uz', label: 'Oʻzbekcha' },
  { code: 'ru', label: 'Русский' },
  { code: 'en', label: 'English' },
];

const SUPPORTED_CODES = GENERATION_LANGUAGES.map((l) => l.code);

/** Starts on the language the user is already working in; falls back to Uzbek. */
export function defaultGenerationLanguage(uiLanguage?: string): string {
  const code = (uiLanguage ?? '').slice(0, 2).toLowerCase();
  return SUPPORTED_CODES.includes(code) ? code : 'uz';
}
